import { useQuery } from "react-query";
import { useContext } from "react";
import { FetchContext } from "../context/FetchContext";

export const useScreeshots = (projectId) => {
  const fetchContext = useContext(FetchContext);

  return useQuery(["project", projectId, "screenshots"], async () => {
    const { data } = await fetchContext.authAxios.get(
      `/projects/${projectId}/screenshots`
    );
    return data;
  });
};
